import Component from 'flarum/common/Component';

export default class SiteSplash extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }

  view() { 
    // we already hassled them, show noting
    if ( sessionStorage.getItem('ageVerify') == 'true') {
        return "";
    }

    let nsfw = false;

    // HARDCODE! WORKS ONLY FOR STARSHINE FORUM
    if (app.current.data.discussion) {
      let tags = app.current.data.discussion.data.relationships.tags.data;
      for (let i = 0; i < tags.length; i++) {
        if (tags[i].id == "34") {
          nsfw = true;
        }
      }
    }

    if (app._title) {
      if (app._title == "NSFW") {
        nsfw = true;
      }
    }

//    if (app.discussions.pages && app.current.data.routeName == "index") {
//      for (let i = 0; i < app.discussions.pages.length; i++) {
//        for (let j = 0; j < app.discussions.pages[i].items.length; j++) {
//          if (app.discussions.pages[i].items[j].data.relationships.tags.data[0].id == "33") {
//            let item = document.querySelector('[data-id="' + app.discussions.pages[i].items[j].data.id + '"]');
//            if (item) {
//              item.style.display = "none";
//              item.classList.add("blur");
//            }
//          }
//        }
//      }
//    }

    if (!nsfw) {
      return "";
    }

    /* if (app.current.data.user)
    {
      console.log(app.current.data);
      let discussions = app.current.data.user.store.data.discussions;
      let nsfw = false;
      if (!nsfw) {
        return "";
      }
    } */

    if( ! this.attrs.enterText ) this.attrs.enterText = app.forum.attribute("age_yes")
    if( ! this.attrs.exitText ) this.attrs.exitText = app.forum.attribute("age_no")
    if( ! this.attrs.verifyPrompt ) this.attrs.verifyPrompt = app.forum.attribute("age_prompt")
    
    //we don't know them, prompt with screenblock (from https://codepen.io/amirnaeem/pen/GZmXwr)
    $('.thegoods').addClass("blur")
    return (
      <div class="nonobox">
          <div class="verifybox">
              <div class="verifybox-left" style={{backgroundImage: "url(" + app.forum.attribute('age_image') + ")",backgroundPosition: "50% 50%"}}>
                  <p> {app.forum.attribute('age_message')} </p>
              </div>
              <div class="verifybox-right">
                  <h3>Предупреждение о нежелательном контенте</h3>
                  <p>{this.attrs.verifyPrompt}</p>
                  <button class="btn btn-alpha" id="consent-exit" 
                      onclick={(e)=>{
                          window.history.back()
                          sessionStorage.setItem('ageVerify','false');
                          }} >
                      {this.attrs.exitText}
                  </button>
                  
                  <p class="decor-line"><span>Или</span></p>

                  <button id='consent-enter' class="btn btn-beta" 
                      onclick={(e)=>{
                          $('.thegoods').removeClass('blur')
                          $('.box').hide();
                          sessionStorage.setItem('ageVerify','true');
                          }} >
                      { this.attrs.enterText}
                  </button>
              </div>
          </div>
      </div>
    );
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }
}
